import { useCallback, useEffect, useRef, useState } from "react";

const DEFAULT_OPTIONS = {
  enableHighAccuracy: true,
  timeout: 10000,
  maximumAge: 0,
};

export function useGeoLocation(options = {}) {
  const [state, setState] = useState({
    status: "idle",
    latitude: null,
    longitude: null,
    error: null,
  });
  const optionsRef = useRef(options);

  useEffect(() => {
    optionsRef.current = options;
  }, [options]);

  const locate = useCallback(() => {
    if (!("geolocation" in navigator)) {
      setState((s) => ({ ...s, status: "unsupported", error: "Geolocation is not supported by this browser." }));
      return;
    }
    setState((s) => ({ ...s, status: "locating", error: null }));
    const mergedOptions = { ...DEFAULT_OPTIONS, ...optionsRef.current };

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        setState({ status: "success", latitude, longitude, error: null });
      },
      (err) => {
        const messages = {
          1: "Location permission denied. Please allow location access to mark attendance.",
          2: "Location unavailable. Please check your device GPS/network.",
          3: "Location request timed out. Please try again.",
        };
        setState((s) => ({ ...s, status: "error", error: messages[err.code] || "Unable to fetch location." }));
      },
      mergedOptions,
    );
  }, []);

  useEffect(() => {
    locate();
  }, [locate]);

  return {
    ...state,
    isLoading: state.status === "locating",
    refetch: locate,
  };
}
